var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { ForwardArrow } from "../icons/forward";
import { MediaVideoComponent } from "../MediaVideo/MediaVideo";
import { MediaVidyardComponent } from "../MediaVidyard/MediaVidyard";
import { RowStyle } from "../theme/common";
import { COMMON, SPACING } from "../theme/palette";
import { ImageSectionStyle, SectionTextStyle } from "./Styles";
const TabPannelStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.common.white,
    "borderRadius": COMMON.borderRadius,
    "color": theme.palette.common.black,
    "padding": SPACING.spacesL
}));
const TabPanel = (props) => {
    const { children, index, value } = props, other = __rest(props, ["children", "index", "value"]);
    return (_jsx(TabPannelStyle, Object.assign({ "aria-labelledby": `simple-tab-${index}`, hidden: value !== index, id: `simple-tabpanel-${index}`, role: "tabpanel" }, other, { children: value === index ? _jsx(Box, Object.assign({ sx: { "p": 3 } }, { children: children })) : _jsx(_Fragment, {}) })));
};
const a11yProps = (index) => ({
    "aria-controls": `simple-tabpanel-${index}`,
    "id": `simple-tab-${index}`,
});
export const DNBTabs = (props) => {
    const { tabs } = props;
    const [value, setValue] = useState(0);
    const handleChange = (ev, newValue) => {
        console.log(ev);
        setValue(newValue);
    };
    return (_jsxs(Box, { children: [_jsx(Tabs, Object.assign({ "aria-label": "Products tabs ", centered: true, onChange: handleChange, value: value }, { children: tabs.map((ele, index) => (_jsx(Tab, Object.assign({ label: ele.tabTitle }, a11yProps(index)), index))) })), tabs.map((ele, index) => (_jsx(TabPanel, Object.assign({ index: index, value: value }, { children: _jsxs(RowStyle, { children: [_jsx(ImageSectionStyle, { children: isNotUndefinedOrNull(ele.tabVideoId) ? (_jsx(_Fragment, { children: isNotUndefinedOrNull(ele.tabVideoType) && ele.tabVideoType === "vidyard" ? (_jsx(MediaVidyardComponent, { id: ele.tabVideoId })) : (_jsx(MediaVideoComponent, { showMissingVideoIdWarning: true, thumbnailImage: ele.tabImage, videoId: ele.tabVideoId })) })) : (_jsx("img", { alt: ele.tabTitle, src: ele.tabImage })) }), isNotUndefinedOrNull(ele.tabDescription) ? (_jsxs(SectionTextStyle, { children: [_jsx("div", { dangerouslySetInnerHTML: { "__html": ele.tabDescription } }), isNotUndefinedOrNull(ele.tabButtonText) && isNotUndefinedOrNull(ele.tabButtonLink) ? (_jsxs(Button, Object.assign({ color: "primary", href: ele.tabButtonLink, size: "medium", variant: "contained" }, { children: [ele.tabButtonText, " ", _jsx(ForwardArrow, { width: "14px" })] }))) : (_jsx(_Fragment, { children: " " }))] })) : (_jsx(_Fragment, { children: " " }))] }) }), index)))] }));
};
